import { redactSecrets, SECRET_MASK } from '../components/chat/redact-secrets';

const ENV_MASKED_METHODS = new Set(['tools.addLocalMCP', 'tools.updateLocalMCP']);
const ENV_VALUE_KEYS = new Set(['env', 'env_set']);

function maskEnvMap(value: unknown): unknown {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return SECRET_MASK;
  return Object.fromEntries(Object.keys(value).map((name) => [name, SECRET_MASK]));
}

function maskEnvValues(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(maskEnvValues);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([k, v]) =>
        ENV_VALUE_KEYS.has(k) ? [k, maskEnvMap(v)] : [k, maskEnvValues(v)],
      ),
    );
  }
  return value;
}

export function startsAProgramOnThisComputer(resource: string, method: string): boolean {
  return ENV_MASKED_METHODS.has(`${resource}.${method}`);
}

export function previewArguments(
  resource: string,
  method: string,
  args: Record<string, unknown>,
): Record<string, unknown> {
  const redacted = redactSecrets(args) as Record<string, unknown>;
  if (!ENV_MASKED_METHODS.has(`${resource}.${method}`)) return redacted;
  return maskEnvValues(redacted) as Record<string, unknown>;
}
